<template>
	<div class="checkable input" :class="{'checkable--non-text-label': !labelIsText}">
		<div v-if="readonly" class="is-read-only">{{ displayValue || "&nbsp;" }}</div>
		<el-checkbox v-else v-model="internalValue" v-bind="$attrs" :label="label" @change="handleChange">
			<slot></slot>
		</el-checkbox>
	</div>
</template>

<script>
	import Vue from 'vue';
	import { Checkbox } from '@cognitoforms/element-ui';

	Vue.use(Checkbox);

	export default Vue.extend({
		name: 'CCheckbox',
		inheritAttrs: false,
		model: {
			prop: 'checked',
			event: 'change'
		},
		props: {
			label: { type: String, default: '' },
			checked: Boolean,
			readonly: Boolean,
			native: Boolean,
			activeText: { type: String, default: '' },
			inactiveText: { type: String, default: '' },
			labelIsText: { type: Boolean, default: true }
		},
		data: function () {
			return {
				hasFocus: false,
				internalValue: this.checked
			};
		},
		computed: {
			displayValue() {
				return this.internalValue ? this.activeText : this.inactiveText;
			}
		},
		watch: {
			checked: function (checked) {
				this.internalValue = checked;
			}
		},
		methods: {
			handleChange(value, ev) {
				this.internalValue = value;
				this.$emit('change', value, ev);
			}
		}
	});
</script>
<style lang="scss" src="@cognitoforms/styles/app/common/_checkables.scss"></style>
<style lang="scss">
.checkable.input {

	.el-checkbox__inner {
		vertical-align: middle;
	}

	.el-checkbox__label {
		overflow-wrap: anywhere;
	}
}

.el-checkbox,
.el-radio {
	display: flex;
	align-items: center;

	[type='checkbox'],
	[type='radio'] {
		@include visually-hidden;
	}

	&__inner {
		display: inline-block;
		width: 1.1em;
		height: 1.1em;
		background: white;
		border: 1px solid var(--border-input);
		box-shadow: none;
		outline: 3px solid transparent;
		vertical-align: text-top;
		transition: all .2s;
	}

	:not(.checkable--non-text-label) > & > .el-checkbox__label {
		margin-left: .25em;
		padding: 6px 0;
		padding-left: .4em;
	}

	&__input {
		display: flex;
		font-size: 1em;
	}
}

.el-checkbox {

	&__inner {
		border-radius: 0;
		transition: all .2s;

		&::after {
			display: block;
			width: 40%;
			height: 70%;
			border: 2px solid var(--shade-1);
			border-top: 0;
			border-left: 0;
			margin: auto;
			margin-top: 5%;
			transform: rotate(45deg) scaleY(0);
			transform-origin: center;
			content: '';
			transition: transform .2s;
		}
	}

	.is-checked &__inner {
		background-color: var(--bg-selected-intense);
		border: 0;

		&::after {
			transform: rotate(45deg) scaleY(1);
		}

		@media print {
			background-color: transparent;

			&::after {
				border: 1.5px solid var(--bg-selected-intense);
				border-top: 0;
				border-left: 0;
			}
		}
	}
}

</style>
